<template>
  <div
    v-if="filter === 'all'"
    id="best-sellers-card"
    class="col-span-2 sm:col-span-3 flex gap-4 items-center min-h-[161px] sm:min-h-[285px] border border-neutral-300 rounded-2xl"
  >
    <div class="flex-center py-2 w-[55%]">
      <a
        href="/products/best-sellers"
        data-gtm-action="best-sellers-card"
      >
        <img
          :src="assetUrl(BestSellersImage)"
          alt="best sellers"
          width="3924"
          height="2568"
          class="object-contain max-h-64"
        >
      </a>
    </div>
    <div class="flex flex-col gap-4 pr-6 sm:pr-10">
      <div
        class="flex flex-col w-32 sm:w-52 font-semibold text-xl leading-5 sm:text-[32px] sm:leading-[32px] tracking-[-0.0225rem]"
      >
        <div>Try Our</div>
        <div>Best Sellers</div>
      </div>
      <a
        href="/products/best-sellers"
        data-gtm-action="best-sellers-card"
        class="button +border +small sm:!min-h-[42px] sm:!py-2"
      >View Now</a>
    </div>
  </div>
</template>

<script setup lang="ts">
import BestSellersImage from '@/assets/images/best-sellers.jpg'
// import { useBreakpoints } from '@/plugins/global'
import { useProductsStore } from '@/stores'
import { assetUrl } from '@/utils'
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'

// const { sm } = useBreakpoints()
const store = useProductsStore()

const { filter } = storeToRefs(store)

const moveInProductList = () => {
  const productList = document.getElementById('product-list')
  const bestSellersCard = document.getElementById('best-sellers-card')
  if (productList && bestSellersCard) {
    const destinationIndex = 9 //sm.value ? 6 : 9
    const children = productList.children

    if (bestSellersCard.parentNode) {
      bestSellersCard.parentNode.removeChild(bestSellersCard)
    }

    if (children.length >= destinationIndex) {
      productList.insertBefore(bestSellersCard, children[destinationIndex])
    } else {
      productList.appendChild(bestSellersCard)
    }
  }
}

onMounted(moveInProductList)
// watch(sm, moveInProductList)
</script>
